import { render, staticRenderFns } from "./AlignmentsMobile.vue?vue&type=template&id=d13fceac&scoped=true&"
import script from "./AlignmentsMobile.vue?vue&type=script&lang=ts&"
export * from "./AlignmentsMobile.vue?vue&type=script&lang=ts&"
import style0 from "./AlignmentsMobile.vue?vue&type=style&index=0&id=d13fceac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13fceac",
  null
  
)

export default component.exports